import Dropdown from '@stimulus-components/dropdown'

/**
 * Disclosure behaviour on top of the upstream dropdown: keeps the trigger's
 * `aria-expanded` in step with the panel and lets Escape close an open panel,
 * returning focus to the trigger.
 */
export default class extends Dropdown {
  toggle() {
    super.toggle()
    this.syncExpanded()
  }

  hide(event) {
    super.hide(event)
    this.syncExpanded()
  }

  close(event) {
    if (!this.transitioned) return

    event.stopPropagation()
    this.leave()
    this.syncExpanded()
    this.triggerElement?.focus()
  }

  syncExpanded() {
    this.triggerElement?.setAttribute('aria-expanded', String(Boolean(this.transitioned)))
  }

  get triggerElement() {
    return this.element.querySelector('[aria-controls]')
  }
}
